<template>
  <div class="aboutUs">
    <div class="h-banner">
      <div class="container">
        <h1>关于我们</h1>
        <p>云端GPU算力服务提供商<br/>致力提供普惠超算中心</p>
      </div>
    </div>
    <div class="session-1">
      <div class="container">
        <div class="c-caption">公司简介</div>
        <p>云蜂树智（厦门）信息科技有限公司成立于2021-02-10，公司依托海量高性能性价比的GPU资源优势，为客户提供IAAS和PAAS服务，核心宗旨是为AI人工智能、云游戏、云渲染、云转码等重度计算场景提供超高性价比的云计算服务</p>
      </div>
    </div>
    <div class="session-2">
      <div class="container">
        <div class="c-caption">GPU布道者</div>
        <ul class="row">
            <li class="col-sm-4">
              <img src="@/assets/images/aboutUs/about_images_01.png" alt="">
              <div class="info">
                <div class="tit">AI驱动行业裂变</div>
                <div class="txt">企业在信息化、数字化和智能化升级过程中，面临的最大挑战是如何将新技术进行场景化适配。而AI是这个行业创新变革的产物，AI要变得智能，需要经过大规模算力计算之逐步变得智能。</div>
              </div>
            </li>
            <li class="col-sm-4">
              <img src="@/assets/images/aboutUs/about_images_02.png" alt="">
              <div class="info">
                <div class="tit">推动云游戏落地</div>
                <div class="txt">云游戏要大规模推广，除了网络条件需要满足之外，还需要有高性价的GPU算力，否则云游戏的成本会高企从而影响云游戏的普及。</div>
              </div>
            </li>
            <li class="col-sm-4">
              <img src="@/assets/images/aboutUs/about_images_03.png" alt="">
              <div class="info">
                <div class="tit">推动科学计算落地</div>
                <div class="txt">在气象预测、油气勘探、分子动力学需要大规模并行计算的科学计算领域，GPU已在发挥强大的作用。通过提供大规模浮点运算的算力，与弹性计算完美结合，无论在线或离线均能提供高效的计算性能。</div>
              </div>
            </li>
          </ul>
      </div>
    </div>
    <div class="session-3">
      <div class="container">
        <div class="c-caption">联系我们</div>
        <iframe class="map" :src="`${publicPath}map.html`"  width="1000" frameBorder=0 scrolling=no></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
.h-banner{
  color: #fff;
  background: url('../assets/images/aboutUs/about_images_bg_top.png') no-repeat;
  background-size: cover;
  background-position: center;
  height: 500px;
  text-align: center;
  h1{
    font-size: 36px;
    font-weight: bold;
    margin-top: 103px;
  }
  p{
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 70px;
    margin-left: auto;
    margin-right: auto;
    max-width: 870px;
  }
}
.c-caption{
  font-size: 24px;
  font-weight: bold;
  margin-top: 80px;
  margin-bottom: 30px;
}
@media (max-width: $screen-sm-min) {
  .c-caption{
    margin-top: 40px;
  }
}
.session-1{
  p{
    font-size: 16px;
  }
}
.session-2{
  .container{
    ul{
      li{
        position: relative;
        img{
          display: block;
          width: 100%;
        }
        .info{
          color: #fff;
          position: absolute;
          left: 35px;
          right: 35px;
          bottom: 20px;
          .tit{
            font-size: 24px;
            font-weight: bold;
          }
          .txt{
            font-size: 16px;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
.map{
  width: 100%;
  height: 527px;
  margin-bottom: 120px;
}
</style>
